module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 18-4537dfb3bf9cd7cfbd64181b30474244.webp";